import React from "react";
import { useState, useEffect } from "react";
import { api } from "../../../utlis/admin/api.utlis";
import ApiService from "../../../core/services/ApiService";
import SubsPlan from "../../../assets/admin/images/subscriptionplan.png";
import Status6 from "../../../assets/admin/images/imgstatus6.svg";
import Status4 from "../../../assets/admin/images/imgstatus4.svg";
import Icplan from "../../../assets/admin/images/icplan.png";
import { totalPageCalculator, LIMIT } from "../../../utlis/common.utlis";
import DatePicker from "react-datepicker";
import Loader from "../../../layouts/loader/Loader";
import moment from "moment";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

const Page = () => {
  const [payment, setPayment] = useState([]);
  const [paymentLogs, setPaymentLogs] = useState([]);
  const [paymentLogsNon, setPaymentLogsNon] = useState([]);
  const [tab, setTab] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [startDateNon, setStartDateNon] = useState(null);
  const [total, setTotal] = useState(0);
  const [totalNon, setTotalNon] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [pageNumNon, setPageNumNon] = useState(1);
  const [loading, setLoading] = useState(false);

  const getSubscriptionPayment = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("payment logs list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setPayment(response.data.data.totalEarning);
      setPaymentLogs(response.data.data.subscriptionPayment);
      setTotal(response.data.data.total);
    } else {
      setPaymentLogs([]);
    }
    setLoading(false);
  };

  const getNonSubscriptionPayment = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("payment logs list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setPaymentLogsNon(response.data.data.nonSubscriptionPayment);
      setTotalNon(response.data.data.total);
    } else {
      setPaymentLogsNon([]);
    }
    setLoading(false);
  };

  const handleFilter = (e, date = null) => {
    e.persist();
    let name = "";
    let dateRange = "";
    let filterType = "";
    if (e.target.name === "name") name = e.target.value;
    if (e.target.name === "dateRange") dateRange = e.target.value;
    if (e.target.name === "filterType") filterType = e.target.value;
    if (date != null && date != undefined && date != "")
      date = moment(date).format("yyyy-MM-DD");
    else date = "";
    getSubscriptionPayment(
      api.paymentLogs +
        `?page=${pageNum}&limit=${LIMIT}&search=${name}&filterType=${filterType}&date=${date}&dateRange=${dateRange}`
    );
  };

  const handleFilterNon = (e, date = null) => {
    e.persist();
    let name = "";
    let dateRange = "";
    let filterType = "";
    if (e.target.name === "name") name = e.target.value;
    if (e.target.name === "dateRange") dateRange = e.target.value;
    if (e.target.name === "filterType") filterType = e.target.value;
    if (date != null && date != undefined && date != "")
      date = moment(date).format("yyyy-MM-DD");
    else date = "";
    getNonSubscriptionPayment(
      api.nonSubscription +
        `?page=${pageNum}&limit=${LIMIT}&search=${name}&filterType=${filterType}&date=${date}&dateRange=${dateRange}`
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (tab == 1) {
      getSubscriptionPayment(
        api.paymentLogs + `?page=${pageNum}&limit=${LIMIT}`
      );
    }
    if (tab == 2) {
      getNonSubscriptionPayment(
        api.nonSubscription + `?page=${pageNumNon}&limit=${LIMIT}`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum, tab, pageNumNon]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="care-title-header">
          <h2 className="heading-title">Payment Logs</h2>
        </div>

        <div className="messages-tab">
          <ul className="nav nav-tabs">
            <li>
              <Link
                className={tab == 1 ? "active" : ""}
                onClick={() => setTab(1)}
                to=""
                data-bs-toggle="tab"
              >
                Subscription
              </Link>
            </li>
            <li>
              <Link
                className={tab == 2 ? "active" : ""}
                onClick={() => setTab(2)}
                to=""
                data-bs-toggle="tab"
              >
                Non Subscription
              </Link>
            </li>
          </ul>
        </div>

        {tab == 1 ? (
          <>
            <div className="payment-overview-section mb-3">
              <div className="row">
                <div className="col-md-5">
                  <div className="card ">
                    <div className="card statistics-card-1 bg-brand-color-4 bg-card-payment-1 card-img-holder text-dark position-relative">
                      <div className="card-body">
                        <img
                          src={Status6}
                          alt="img"
                          className=" img-bg"
                          style={{ opacity: "0.3" }}
                        />
                        <h6 className="font-weight-normal mb-4">Total Subscription Payment</h6>
                        <div className="d-flex justify-content-between align-items-center">
                          <h3 className="mb-0">
                            ${payment[0]?.total_subscription_payment ?? 0}
                          </h3>
                          <div className="active-jobs-img">
                            <img src={Icplan} alt="" height={50} />{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-3">
                  <div className="card">
                    <div className="card statistics-card-1  bg-brand-color-2 bg-card-payment-1 card-img-holder text-dark position-relative">
                      <div className="card-body">
                        <img
                          src={Status4}
                          alt="img"
                          className=" img-bg"
                          style={{ opacity: "0.3" }}
                        />
                        <h6 className="font-weight-normal mb-4">Plan B</h6>
                        <div className="d-flex justify-content-between align-items-center">
                          <h3 className="mb-0">
                            ${payment[0]?.total_payment_plan_2 ?? 0}
                          </h3>
                          <div className="active-jobs-img">
                            <img src={Icplan} alt="" height={50} />{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card">
                    <div className="card statistics-card-1 bg-brand-color-3 bg-card-payment-1 card-img-holder text-dark position-relative">
                      <div className="card-body">
                        <img
                          src={Status4}
                          alt="img"
                          className="img-bg"
                          style={{ opacity: "0.3" }}
                        />
                        <h6 className="font-weight-normal mb-4">Plan C</h6>
                        <div className="d-flex justify-content-between align-items-center">
                          <h3 className="mb-0">
                            ${payment[0]?.total_payment_plan_3 ?? 0}
                          </h3>
                          <div className="active-jobs-img">
                            <img src={Icplan} alt="" height={50} />{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card">
                    <div className="card statistics-card-1 bg-brand-color-4 bg-card-payment-1 card-img-holder text-dark position-relative">
                      <div className="card-body">
                        <img
                          src={Status4}
                          alt="img"
                          className=" img-bg"
                          style={{ opacity: "0.3" }}
                        />
                        <h6 className="font-weight-normal mb-4">Plan D</h6>
                        <div className="d-flex justify-content-between align-items-center">
                          <h3 className="mb-0">
                            ${payment[0]?.total_payment_plan_4 ?? 0}
                          </h3>
                          <div className="active-jobs-img">
                            <img src={Icplan} alt="" height={50} />{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="cc-table-card">
              <div className="cc-search-filter">
                <div className="row g-2">
                  <div className="col-md-4">
                    <div className="form-group">
                      <select
                        className="form-control"
                        name="dateRange"
                        onChange={(e) => handleFilter(e)}
                      >
                        <option value="">Select Date Range</option>
                        <option value="current_month">Current Month</option>
                        <option value="last_1_month">Last 1 Month</option>
                        <option value="last_3_month">Last 3 Month</option>
                        <option value="last_6_month">Last 6 Month</option>
                        <option value="last_1_year">Last 1 Year</option>
                        <option value="last_2_years">Last 2 Year</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <DatePicker
                        toggleCalendarOnIconClick
                        showIcon
                        dateFormat={"MM-dd-yyyy"}
                        selected={startDate}
                        onChange={(date, e) => {
                          setStartDate(date);
                          handleFilter(e, date);
                        }}
                        className="DatePicker-control"
                        style={{ padding: "15px 40px" }}
                        isClearable
                        autoComplete="off"
                        name="date"
                        placeholderText="Select Date"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group search-form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search here..."
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        onChange={(e) => handleFilter(e)}
                        name="name"
                      />
                      <span className="search-icon">
                        <i className="cc-input-group-text  mdi mdi-magnify"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-2">
                <table className="table">
                  <thead>
                    <tr>
                      <th> Plan Name</th>
                      <th> Care Giver Name</th>
                      <th> Care Provider Name </th>
                      <th> Amount Received </th>
                      <th> Purchased Order Date & Time</th>
                      <th> Auto Renewal Notice Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentLogs.length !== 0 ? (
                      paymentLogs.map((ele, indx) => {
                        return (
                          <tr key={indx}>
                            <td> {ele.name ?? "NA"} </td>
                            <td> {ele.careGiverName ?? "NA"} </td>
                            <td> {ele.careProviderName ?? "NA"} </td>
                            <td> ${ele.amountReceived ?? 0} </td>
                            <td>
                              {" "}
                              {moment(ele.purchasedOrderDateTime).format(
                                "MM-DD-yyyy, hh:mmA"
                              )}{" "}
                            </td>
                            <td>
                              {" "}
                              {ele.autoRenewalNoticeDate
                                ? moment(ele.autoRenewalNoticeDate).format(
                                    "MM-DD-yyyy"
                                  )
                                : "NA"}{" "}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="text-center">
                        <td colSpan={6}>No payments found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-flex align-items-center justify-content-center mt-3">
                  {paymentLogs.length !== 0 ? (
                    <div className="care-table-pagination">
                      <ul className="care-pagination">
                        {pageNum !== 1 && (
                          <li
                            className="disabled"
                            id="example_previous"
                            onClick={() => setPageNum(pageNum - 1)}
                          >
                            <Link
                              to=""
                              aria-controls="example"
                              data-dt-idx="0"
                              tabIndex="0"
                              className="page-link"
                            >
                              Previous
                            </Link>
                          </li>
                        )}

                        {totalPageCalculator(total, LIMIT).length === 1
                          ? null
                          : totalPageCalculator(total, LIMIT).map(
                              (pageNo, indx) => {
                                return (
                                  <li
                                    className={
                                      pageNo === pageNum ? "active" : ""
                                    }
                                    key={indx}
                                    onClick={() => setPageNum(pageNo)}
                                  >
                                    <Link to="" className="page-link">
                                      {pageNo}
                                    </Link>
                                  </li>
                                );
                              }
                            )}

                        {pageNum !== Math.ceil(total / LIMIT) && (
                          <li
                            className="next"
                            id="example_next"
                            onClick={() => setPageNum(pageNum + 1)}
                          >
                            <Link
                              to=""
                              aria-controls="example"
                              data-dt-idx="7"
                              tabIndex="0"
                              className="page-link"
                            >
                              Next
                            </Link>
                          </li>
                        )}
                      </ul>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="cc-table-card">
            <div className="cc-search-filter">
              <div className="row g-2">
                <div className="col-md-4">
                  <div className="form-group">
                    <select
                      className="form-control"
                      name="dateRange"
                      onChange={(e) => handleFilterNon(e)}
                    >
                      <option value="">Select Date Range</option>
                      <option value="current_month">Current Month</option>
                      <option value="last_1_month">Last 1 Month</option>
                      <option value="last_3_month">Last 3 Month</option>
                      <option value="last_6_month">Last 6 Month</option>
                      <option value="last_1_year">Last 1 Year</option>
                      <option value="last_2_years">Last 2 Year</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <DatePicker
                      toggleCalendarOnIconClick
                      showIcon
                      dateFormat={"MM-dd-yyyy"}
                      selected={startDateNon}
                      onChange={(date, e) => {
                        setStartDateNon(date);
                        handleFilterNon(e, date);
                      }}
                      className="DatePicker-control"
                      style={{ padding: "15px 40px" }}
                      isClearable
                      autoComplete="off"
                      name="date"
                      placeholderText="Select Date"
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group search-form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here..."
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      onChange={(e) => handleFilterNon(e)}
                      name="name"
                    />
                    <span className="search-icon">
                      <i className="cc-input-group-text  mdi mdi-magnify"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive mt-2">
              <table className="table">
                <thead>
                  <tr>
                    <th> Transaction ID </th>
                    <th> Payer Name</th>
                    <th> Care Provider Name </th>
                    <th> Amount Received </th>
                    <th> Payment Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentLogsNon.length !== 0 ? (
                    paymentLogsNon.map((ele, indx) => {
                      return (
                        <tr key={indx}>
                          <td> {ele.transaction_id ?? "NA"} </td>
                          <td> {ele.payerName ?? "NA"} </td>
                          <td> {ele.careProviderName ?? "NA"} </td>
                          <td> ${ele.amountReceived ?? 0} </td>
                          <td>
                            {" "}
                            {moment(ele.paymentDate).format(
                              "MM-DD-yyyy hh:mm A"
                            )}{" "}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan={6}>No payments found</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="d-flex align-items-center justify-content-center mt-3">
                {paymentLogsNon.length !== 0 ? (
                  <div className="care-table-pagination">
                    <ul className="care-pagination">
                      {pageNumNon !== 1 && (
                        <li
                          className="disabled"
                          id="example_previous"
                          onClick={() => setPageNumNon(pageNumNon - 1)}
                        >
                          <Link
                            to=""
                            aria-controls="example"
                            data-dt-idx="0"
                            tabIndex="0"
                            className="page-link"
                          >
                            Previous
                          </Link>
                        </li>
                      )}

                      {totalPageCalculator(totalNon, LIMIT).length === 1
                        ? null
                        : totalPageCalculator(totalNon, LIMIT).map(
                            (pageNo, indx) => {
                              return (
                                <li
                                  className={pageNo === pageNumNon ? "active" : ""}
                                  key={indx}
                                  onClick={() => setPageNumNon(pageNo)}
                                >
                                  <Link to="" className="page-link">
                                    {pageNo}
                                  </Link>
                                </li>
                              );
                            }
                          )}

                      {pageNumNon !== Math.ceil(totalNon / LIMIT) && (
                        <li
                          className="next"
                          id="example_next"
                          onClick={() => setPageNumNon(pageNumNon + 1)}
                        >
                          <Link
                            to=""
                            aria-controls="example"
                            data-dt-idx="7"
                            tabIndex="0"
                            className="page-link"
                          >
                            Next
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Page;
